import React, { useEffect, useCallback, useRef } from 'react';
import { observer } from 'mobx-react-lite';

import { BaseStep, StepProps, TitleAndDescriptionProps, StepWizardProps } from '../common/BaseStep';
import { StepWrapperBox } from '../styledComponent/Boxes.style';
import { Loader } from '../common/Loader';

interface ThinkingStepProps extends StepWizardProps, TitleAndDescriptionProps, StepProps {
  milliseconds?: number;
}

export const ThinkingStep = observer((props: ThinkingStepProps) => {
  const { isActive, nextStep, milliseconds } = props;
  let timeout = useRef<NodeJS.Timeout>();

  const goNextStep = useCallback(() => {
    nextStep();
    clearTimeout(timeout.current);
  }, [nextStep]);

  useEffect(() => {
    if (isActive) {
      timeout.current = setTimeout(goNextStep, milliseconds ?? 3000);
      return window.scrollTo(0, 0);
    }
    return () => {
      clearTimeout(timeout.current);
    };
  }, [isActive, milliseconds, goNextStep]);

  return (
    <>
      {isActive ? (
        <BaseStep {...props}>
          <StepWrapperBox>
            <Loader />
          </StepWrapperBox>
        </BaseStep>
      ) : (
        ''
      )}
    </>
  );
});
